import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Subject } from 'rxjs';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private readonly userKey = 'userkey';

  constructor(
    private cookies: CookieService,
    private encService: EncryptionService
  ) {
  
    const userCookie = this.cookies.get(this.userKey);
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        this.currentUser.next(user);
        this.roleOfLoggedInUser.next(
          parseInt(this.encService.decrypt(user.role))
        );
      } catch (err) {
        console.warn('Invalid user in cookie:', err);
      }
    }
  }
  pageName: BehaviorSubject<string> = new BehaviorSubject<string>('');
  processing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  processingTrackReport: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  currentUser: BehaviorSubject<any> = new BehaviorSubject<any>({
    username: '',
    codeName: '',
    name: '',
    role: '',
    id: '',
  });

  roleOfLoggedInUser: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  heartBeatIndicator: Subject<boolean> = new Subject<boolean>();
  resetLogin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
